CLASSIC_FACET_FILM_TYPE